import { Box } from '@mui/material';
import VoiceSkeleton from '@src/containers/VoiceLibrary/Content/LoadingSkeleton/VoiceSkeleton';
import VoiceList from '@src/containers/VoiceLibrary/Content/VoiceList';
import React from 'react';

const RankingList = ({
  isLoading,
  voiceList,
  favouriteVoiceCodes,
  onFavoriteToggleRequest,
  onHandleFavoriteProcessingComplete,
  onErrorProcessingFavouriteVoices,
}) => (
  <Box className="voice-list-container-result">
    {isLoading ? (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {Array.from({ length: 7 }).map(() => (
          <VoiceSkeleton />
        ))}
      </div>
    ) : (
      <VoiceList
        isLeaderboard
        voices={voiceList}
        isCard={false}
        loadMore={() => {}}
        isLoading={isLoading}
        isTrending
        favouriteVoiceCodes={favouriteVoiceCodes}
        onFavoriteToggleRequest={onFavoriteToggleRequest}
        onHandleFavoriteProcessingComplete={onHandleFavoriteProcessingComplete}
        onErrorProcessingFavouriteVoices={onErrorProcessingFavouriteVoices}
      />
    )}
  </Box>
);

export default RankingList;
